import {locationDetails} from "@adi/location-details";

const fbSubscribePage = window.location.href.match(/\:\/\/[^/]+?\/(login)/);
const affiliateSettings = {
    al: {
        tier: {
            dev: {
                pianoKey: "o1cK4e7wZz",
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    cleveland: {
        tier: {
            dev: {
                pianoKey: "Upv3SBLMVo",
            },
            prod: {
                pianoKey: "pZpDrRDtBy",
            },
        },
    },
    gulflive: {
        tier: {
            dev: {
                pianoKey: null,
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    lehighvalleylive: {
        tier: {
            dev: {
                pianoKey: null,
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    masslive: {
        tier: {
            dev: {
                pianoKey: null,
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    mlive: {
        tier: {
            dev: {
                pianoKey: "AeIH5h5Zwc",
                pianoEnabled: true,
            },
            prod: {
                pianoKey: "8Gu2Z8RCvZ",
            },
        },
    },
    nj: {
        tier: {
            dev: {
                pianoKey: "rrzBdMVdCZ",
            },
            prod: {
                pianoKey: "mq4ucQHSOB",
            },
        },
    },
    newyorkupstate: {
        tier: {
            dev: {
                pianoKey: null,
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    oregonlive: {
        tier: {
            dev: {
                pianoKey: "YPTRqUvNdh",
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    pennlive: {
        tier: {
            dev: {
                pianoKey: "lyiwJjYKFk",
                pianoEnabled: true,
            },
            prod: {
                pianoKey: "8MqqMCr7IT",
                pianoEnabled: true,
            },
        },
    },
    silive: {
        tier: {
            dev: {
                pianoKey: null,
            },
            prod: {
                pianoKey: null,
            },
        },
    },
    syracuse: {
        tier: {
            dev: {
                pianoKey: "3e5ZKAmdJA",
                pianoEnabled: true,
                fbEnabled: fbSubscribePage,
            },
            prod: {
                fbEnabled: fbSubscribePage,
                pianoKey: "w76gCnIVd6",
                pianoEnabled: true,
            },
        },
    },
};
const {
    pianoKey, pianoEnabled, fbEnabled,
} = affiliateSettings[locationDetails.affiliate].tier[locationDetails.tier];
export {pianoKey, pianoEnabled, fbEnabled};
